import { is } from 'ramda'

export const getGetSingleConditionValue = (conditions = [], key) => {
  const value = conditions.find(
    item => [undefined, null, 'eq'].includes(item.operator) && item.field?.endsWith(key)
  )?.value
  if (is(Number, value)) return value
  if (is(Object, value)) return value?.id
  return undefined
}
